// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddChild_footer__1vYO1"};